import { gql } from '@apollo/client';
import { itemsFragment, searchResultItemFragment } from '../fragments/items';

export const vipItemsQuery = gql`
  query VipItems($filter: ItemFilter, $limit: Limit!, $offset: Int!) {
    items(filter: $filter, limit: $limit, offset: $offset) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;

export const featuredItemsRowQuery = gql`
  query FeaturedItemsRow($limit: Limit!, $offset: Int!) {
    featuredItems: items(
      filter: { scope: FEATURED }
      limit: $limit
      offset: $offset
    ) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;

export const searchVippedAllQuery = gql`
  query SearchVippedAll(
    $vipLimit: Limit!
    $vipFilter: ItemFilter
    $residenceLimit: Limit!
    $residenceFilter: ItemFilter
    $sort: ItemSort!
  ) {
    vipItems: items(limit: $vipLimit, filter: $vipFilter, sort: $sort) {
      ...searchResultItem
    }
    vipResidenceItems: items(
      limit: $residenceLimit
      filter: $residenceFilter
      sort: $sort
    ) {
      ...searchResultItem
    }
  }
  ${searchResultItemFragment}
`;

export const residenceItemsQuery = gql`
  query ResidenceItems($filter: ItemFilter, $limit: Limit!, $sort: ItemSort!) {
    items(filter: $filter, limit: $limit, sort: $sort) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;
